const initialPageNumber = 1;
const maxPerPage = 4;

export { initialPageNumber, maxPerPage };
